import * as React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  const {
    site: { siteMetadata },
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            social {
              twitter
            }
          }
        }
      }
    `,
  )

  let header

  if (isRootPath) {
    header = (
      <h1 id='site-title' className='main-heading'>
        <Link to='/'>{title}</Link>
      </h1>
    )
  } else {
    header = (
      <Link className='header-link-home' to='/'>
        {title}
      </Link>
    )
  }

  const twitterUrl = `https://twitter.com/${siteMetadata.social.twitter}`

  return (
    <div className='global-wrapper' data-is-root-path={isRootPath}>
      <header className='global-header'>{header}</header>
      <main>{children}</main>
      <footer>
        by{' '}
        <a href={twitterUrl} target='_blank' rel='noreferrer'>
          @{siteMetadata.social.twitter}
        </a>
      </footer>
    </div>
  )
}

export default Layout
